import { z } from 'zod';

export const FormSchema = z.object({
  ma_nhom: z.string().nonempty('Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().nonempty('Tên phân nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().nonempty('Trạng thái là bắt buộc')
});
export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_nhom: '',
  ten_phan_nhom: '',
  ten2: '',
  trang_thai: '1'
};

export const SearchFormSchema = z.object({
  ma_loai_nh: z.string().min(1, 'Mã loại nhóm là bắt buộc')
});
export type SearchFormValues = z.infer<typeof SearchFormSchema>;

export const initialSearchValues: SearchFormValues = {
  ma_loai_nh: ''
};
